<div class="ap-flex ap-flex-grow-1 chat-position-relative">
    <div
        class="ap-flex-grow-1 ap-padding-horizontal-2 ap-padding-top-2 ap-margin-bottom-2 ap-flex-fill conversational-chat-message-container"
        #scrollChatContainer
        [attr.aria-label]="'klant.conversational.aria.chatmessages' | apContent"
    >
        @defer (when chatMessages().length) {
            <conversational-chat-disclaimer></conversational-chat-disclaimer>

            <div role="log" aria-atomic="false" aria-live="off">
                @for (messageGroup of groupedMessagesByDate(); track messageGroup.date) {
                    <message-date-divider [date]="messageGroup.date"></message-date-divider>
                    @for (chatMessage of messageGroup.chatMessages; track chatMessage; let indexInGroup = $index) {
                        <conversational-chat-message
                            [chatMessage]="chatMessage"
                            [isLastMessage]="isLastMessage(chatMessage)"
                            [showAvatar]="showAvatar(chatMessage, indexInGroup, messageGroup)"
                            (sendAction)="onSendAction($event)"
                        >
                        </conversational-chat-message>
                    }
                }

                @if (messageLoading()) {
                    <message-loader
                        [avatarBotOrLive]="botOrLivechatAvatar()"
                        [showAvatar]="showMessageLoaderAvatar()"
                        class="ap-flex ap-margin-bottom-2 ap-justify-content-start"
                    ></message-loader>
                }
            </div>
        } @placeholder {
            <ap-skeleton data-testid="loading">
                <div class="ap-margin-bottom-6">
                    <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
                    <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
                </div>

                <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                </div>

                <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                </div>

                <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                </div>

                <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                    <div class="ap-col-span-6"></div>
                    <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
                </div>
            </ap-skeleton>
        }
    </div>
</div>

@defer (when chatMessages().length) {
    <conversational-chat-input
        #chatInputContainer
        [attr.aria-label]="'klant.conversational.aria.inputarea' | apContent"
        class="ap-flex ap-flex-column ap-justify-content-end ap-margin-horizontal-1 ap-margin-top-2"
        [hideSafetyNotification]="firstMessageWasSent()"
        (sendMessage)="onSendMessage($event)"
        (firstMessageSent)="onFirstMessageSent($event)"
    >
    </conversational-chat-input>
} @placeholder {
    <div class="ap-display-block ap-margin-2">
        <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
        <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
    </div>
}
